(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("EmploymentReverificationModal", EmploymentReverificationModal);

    EmploymentReverificationModal.$inject = ['$scope', 'modalData', 'hFormsService', 'onSave', 'localize'];

    function EmploymentReverificationModal($scope, modalData, hFormsService, onSave, localize) {
        var self = this;

        self.data = {};

        var EmploymentReverificationForm = hFormsService.getForm("employmentReverificationForm");
        self.employmentReverificationForm = new EmploymentReverificationForm($scope, "employment-reverification-form");

        self.loading = true;

        localize.loadLocaleScript("en");
        moment.locale("en");

        self.employmentReverificationForm.load(modalData.brandId, modalData.i9EmployerExcludeAttachments, modalData.OBIdObj, modalData.i9Document, modalData.i9ReverificationDocument, modalData.employerPreFillingEnabled)
            .finally(function () {
                delete self.loading;
            });

        self.saveDocument = function () {
            self.saving = true;

            self.employmentReverificationForm.save()
                .then(function (res) {
                    onSave(res);
                    self.close();
                })
                .finally(function () {
                    delete self.saving;
                });
        };

        self.getDocPreviewData = function() {
            var documentPreviewData = angular.copy(self.employmentReverificationForm.data);

            documentPreviewData['code'] = OnBoardingAPI.DOCUMENT_TYPE.I9_REVERIFICATION_SECTION_3;
            documentPreviewData['brand_id'] = modalData.brandId;

            return documentPreviewData;
        };

        self.close = function () {
            localize.loadLocaleScript(localize.getLang());
            moment.locale(localize.getLocaleCode());
            $scope.$hide();
        };
    }
})();
